import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../../services/authService';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();
  const location = useLocation();
  const navigate = useNavigate();
  const companyId = authService.getCompanyId();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }
    if (!companyId && location.pathname !== '/selecionar-empresa') {
      navigate('/selecionar-empresa', { replace: true });
    }
  }, [isAuthenticated, companyId, location.pathname]);

  if (!isAuthenticated) return null;
  if (!companyId && location.pathname !== '/selecionar-empresa') return null;
  return <>{children}</>;
};

export default ProtectedRoute;
